import React from 'react'
import AccountTraceTable from '../../../components/transactionNew/account/AccountTraceTable'
import { useWindowSize } from '../../../modules/staking'
import { MOBILE_SIZE } from '../../../core/constants/common'
import RAccountTraceTable from '../../../components/transactionNew/account/RAccountTraceTable'

const AccountTransactionsHistory = () => {

    const { width } = useWindowSize()

    return (
        <div>
            {width >= MOBILE_SIZE ? <AccountTraceTable /> : <RAccountTraceTable />}
        </div>
    )
}

export default AccountTransactionsHistory